import { ReactComponent as Admin } from "@assets/icons/admin_icon.svg";

const AdminIcon = (props: any): JSX.Element => {
  return (
    <Admin
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default AdminIcon;
